import React, { useState, useEffect } from 'react';
import useStyles from '../../../styles';
import {
  TextField,
  Card,
  CardContent,
  Button,
} from '@material-ui/core';
import { formatDollar } from '../../../lib/fmt';
import { Visibility as ViewIcon} from '@material-ui/icons';
import ClientSummaryMarginReqDetailsModal from './ClientSummaryMarginReqDetailsModal';

export default function ClientSummaryBalanceFields({
  value,
}) {
  const classes = useStyles();
  const [marginReqData, setMarginReqData] = useState({});
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    setMarginReqData({ ...value });
  }, [value]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Card className={classes.root} variant="outlined">
        <CardContent>
          <div>
            <form noValidate autoComplete="off">
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Master Account No"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={marginReqData.masterAccountNo}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Margin Type"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={marginReqData.marginType}
                  />
                </div>
                <div className={classes.grdCell1}>
                  <TextField
                    label="Trade Date"
                    type="date"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={marginReqData.tradeDate}
                  />
                </div>
              </div>
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Cash Balance"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.cashBalance) || 0}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Short Market Value"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.shortMarketValue) || 0}
                  />
                </div>
                <div className={classes.grdCell1}>
                  <TextField
                    label="Long Market Value"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.longMarketValue) || 0}
                  />
                </div>
              </div>
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Equity"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.totalEquity) || 0}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Market Value"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.marketValue) || 0}
                  />
                </div>
                <div className={classes.grdCell1}>
                  <TextField
                    label="Exchange Req"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.exchangeReq) || 0}
                  />
                </div>
              </div>
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Exchange Call"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.exchangeCall) || 0}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Fed Req"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.fedReq) || 0}
                  />
                </div>
                <div className={classes.grdCell1}>
                  <TextField
                    label="Fed Call"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.fedCall) || 0}
                  />
                </div>
              </div>
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="House Req"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.houseReq) || 0}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="House Call"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.houseCall) || 0}
                  />
                </div>
                <div className={classes.grdCell1}>
                  <TextField
                    label="Min Balance Call"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.minBalanceCall) || 0}
                  />
                </div>
              </div>
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="SMA"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.sma) || 0}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Multiplier"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={marginReqData.multiplier}
                  />
                </div>
                <div className={classes.grdCell1}></div>
              </div>
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Buying Power"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.buyingPower) || 0}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    label="Buying Power Used"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.buyingPowerUsed) || 0}
                  />
                </div>
                <div className={classes.grdCell1}>
                  <TextField
                    label="Buying Power Call"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={formatDollar(marginReqData.buyingPowerCall) || 0}
                  />
                </div>
              </div>
            </form>
          </div>
        </CardContent>
      </Card>

      <div className={classes.actionContainer}>
        <div className={classes.grdRow}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={<ViewIcon />}
          onClick={() => {
            handleOpen();
          }}
        >
          View Details
        </Button>
        </div>
      </div>
      
      {open && (
        <ClientSummaryMarginReqDetailsModal
          onClose={handleClose}
          open={open}
          value={marginReqData}
        ></ClientSummaryMarginReqDetailsModal>
      )}

    </div>
  );
}
